module.exports = __webpack_public_path__ + "static/media/guide.bea1d0ef.svg";